"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    labelClassNames: function() {
        return labelClassNames;
    },
    useLabelStyles_unstable: function() {
        return useLabelStyles_unstable;
    }
});
const _react = require("@griffel/react");
const labelClassNames = {
    root: 'fui-Label',
    required: 'fui-Label__required'
};
/**
 * Styles for the label
 */ const useStyles = /*#__PURE__*/ (0, _react.__styles)({
    root: {
        Bahqtrf: "fk6fouc",
        sj55zd: "f19n0e5"
    },
    disabled: {
        sj55zd: "f1s2aq7o",
        Bbusuzp: "f1dcs8yz"
    },
    required: {
        sj55zd: "f1whyuy6",
        uwmqm3: [
            "fruq291",
            "f7x41pl"
        ]
    },
    small: {
        Be2twd7: "fy9rknc",
        Bg96gwp: "fwrc4pm"
    },
    medium: {
        Be2twd7: "fkhj508",
        Bg96gwp: "f1i3iumi"
    },
    large: {
        Be2twd7: "fod5ikn",
        Bg96gwp: "faaz57k",
        Bhrd7zp: "fl43uef"
    },
    semibold: {
        Bhrd7zp: "fl43uef"
    }
}, {
    d: [
        ".fk6fouc{font-family:var(--fontFamilyBase);}",
        ".f19n0e5{color:var(--colorNeutralForeground1);}",
        ".f1s2aq7o{color:var(--colorNeutralForegroundDisabled);}",
        ".f1whyuy6{color:var(--colorPaletteRedForeground3);}",
        ".fruq291{padding-left:var(--spacingHorizontalXS);}",
        ".f7x41pl{padding-right:var(--spacingHorizontalXS);}",
        ".fy9rknc{font-size:var(--fontSizeBase200);}",
        ".fwrc4pm{line-height:var(--lineHeightBase200);}",
        ".fkhj508{font-size:var(--fontSizeBase300);}",
        ".f1i3iumi{line-height:var(--lineHeightBase300);}",
        ".fod5ikn{font-size:var(--fontSizeBase400);}",
        ".faaz57k{line-height:var(--lineHeightBase400);}",
        ".fl43uef{font-weight:var(--fontWeightSemibold);}"
    ],
    m: [
        [
            "@media (forced-colors: active){.f1dcs8yz{color:GrayText;}}",
            {
                m: "(forced-colors: active)"
            }
        ]
    ]
});
const useLabelStyles_unstable = (state)=>{
    'use no memo';
    const styles = useStyles();
    state.root.className = (0, _react.mergeClasses)(labelClassNames.root, styles.root, state.disabled && styles.disabled, styles[state.size], state.weight === 'semibold' && styles.semibold, state.root.className);
    if (state.required) {
        state.required.className = (0, _react.mergeClasses)(labelClassNames.required, styles.required, state.disabled && styles.disabled, state.required.className);
    }
    return state;
}; //# sourceMappingURL=useLabelStyles.styles.js.map
